export default __webpack_public_path__ + "static/media/body-detect.0086c545.mp4";